import { motion } from "framer-motion";

/**
 * Slow editorial marquee. Duplicates children to loop seamlessly.
 * Uses Framer Motion so the animation runs reliably.
 * `items` = string[]; dot separator between items.
 */
export default function Marquee({ items, className = "", duration = 30 }) {
  const doubled = [...items, ...items];
  return (
    <div
      className={`relative overflow-hidden border-y border-charcoal/70 py-6 md:py-8 bg-ink ${className}`}
      data-testid="marquee"
    >
      <motion.div
        className="flex gap-8 w-max whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {doubled.map((label, i) => (
          <div key={i} className="flex items-center gap-8 shrink-0">
            <span className="font-display font-extrabold uppercase text-white tracking-[-0.01em] text-3xl md:text-5xl lg:text-6xl">
              {label}
            </span>
            <span className="inline-block w-2.5 h-2.5 rounded-full bg-emerald shrink-0" />
          </div>
        ))}
      </motion.div>
    </div>
  );
}
